import { isString } from 'lodash';
/* eslint-disable no-restricted-globals */
export const isNumeric = (value) => {
  let number = value;
  if (isString(value)) {
    number = value.replace(/,/g, '');
  }
  return !isNaN(parseFloat(number)) && isFinite(number);
};
